import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetNotificationTemplateList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/NotificationTemplate/GetList?` + params, null);

export const GetNotificationTemplateDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/NotificationTemplate/GetDetail?` + params, null);

export const CreateNotificationTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/NotificationTemplate/Create`, data);

export const UpdateNotificationTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/NotificationTemplate/Update`, data);

export const UpdateDefaultNotificationTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/NotificationTemplate/UpdateDefault`, data);

export const DeleteNotificationTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/NotificationTemplate/Delete`, data); 